﻿///<reference path="main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	let gmap;
	let category = -1;

	window.addEventListener( 'DOMContentLoaded', e => {
		gmap = new app.Gmap( app.$( '#gmap' ), mapLoaded );

		app.$.forEach( '.gmap-key-item', el => {
			el.addEventListener( 'click', categorySelect );
		} );
	} );

	function mapLoaded() {
		loadMarkers();
	}

	function categorySelect( e ) {
		if ( this.classList.contains( 'active' ) ) {
			category = -1;
			this.classList.remove( 'active' );
		}
		else {
			if ( app.$( '.gmap-key-item.active' ) ) {
				app.$( '.gmap-key-item.active' ).classList.remove( 'active' );
			}
			
			category = parseInt( this.getAttribute( 'data-category-id' ), 10 );
			this.classList.add( 'active' );
		}
		
		loadMarkers();
		e.preventDefault();
	}

	function loadMarkers() {
		gmap.clearMarkers();

		app.$.fetch( '/api/investmentsGetJson', {
			body: {
				investmentId: -1,
				investmentCategoryId: category,
				active: true
			}
		} ).then( rsp => {
			if ( rsp.success ) {
				let investments = rsp.obj;
				
				investments.forEach( ( inv, i ) => {
					gmap.addMarker( inv, i );
				} );
			}
			else {
				console.log( 'Error loading investments.', rsp || 'No error data.' );
			}
		} ).catch( rsp => {
			console.log( 'Error loading investments.', rsp || 'No error data.' );
		} );
	}

}( document ) );